module.exports = __webpack_public_path__ + "img/skill.9aa56d3a.svg";